import type { TagProps, TagVariant, TagSize } from './types'

const COMMON_LEGACY_PROPS: Omit<TagProps, '$variant' | '$size'> = {
  $fs: '16',
  $radius: '2xl',
  $border: '2px',
  $weight: 'medium',
  $px: '4',
}

export const VARIANT: Record<
  TagVariant,
  Omit<TagProps, '$variant' | '$size'>
> = {
  /** legacy */
  primary: {
    $fg: 'white',
    $bg: 'blueSparkle',
    $borderColor: 'catskillWhite',
    ...COMMON_LEGACY_PROPS,
  },
  /** legacy */
  info: {
    $fg: 'white',
    $bg: 'lynxScreenBlue',
    $borderColor: 'catskillWhite',
    ...COMMON_LEGACY_PROPS,
  },
  /** legacy */
  success: {
    $fg: 'white',
    $bg: 'jocoseJade',
    $borderColor: 'catskillWhite',
    ...COMMON_LEGACY_PROPS,
  },
  /** legacy */
  neutral: {
    $fg: 'white',
    $bg: 'herringSilver',
    $borderColor: 'catskillWhite',
    ...COMMON_LEGACY_PROPS,
  },
  /** legacy */
  warning: {
    $fg: 'white',
    $bg: 'fiveStar',
    $borderColor: 'catskillWhite',
    ...COMMON_LEGACY_PROPS,
  },
  /** legacy */
  warningLight: {
    $fg: 'fiveStar',
    $bg: 'creamyCloudDreams',
    $borderColor: 'fiveStar',
    ...COMMON_LEGACY_PROPS,
  },
  /** legacy */
  danger: {
    $fg: 'white',
    $bg: 'danger',
    $borderColor: 'catskillWhite',
    ...COMMON_LEGACY_PROPS,
  },
  negative: {
    $fg: 'negativeDark',
    $bg: 'negativeBg',
    $radius: 'lg',
    $weight: 'normal',
    $px: '2',
    $py: '1',
  },
  purple: {
    $fg: 'jacarandaPink',
    $bg: 'jacarandaPink',
    $bgOpacity: 0.1,
    $radius: 'lg',
    $weight: 'normal',
    $px: '2',
    $py: '0.5',
  },
  blue: {
    $fg: 'blueSparkle',
    $bg: 'blueSparkle',
    $bgOpacity: 0.1,
    $radius: 'lg',
    $weight: 'normal',
    $px: '2',
    $py: '0.5',
  },
  yellow: {
    $fg: 'veryCoffee',
    $bg: 'momsPancake',
    $bgOpacity: 0.2,
    $radius: 'lg',
    $weight: 'normal',
    $px: '2',
    $py: '0.5',
  },
  pumpkin: {
    $fg: 'pumpkinSoup',
    $bg: 'pumpkinSoup',
    $bgOpacity: 0.1,
    $radius: 'lg',
    $weight: 'normal',
    $px: '2',
    $py: '0.5',
  },
  sapphire: {
    $fg: 'sapphireDark',
    $bg: 'sapphireDark',
    $bgOpacity: 0.1,
    $radius: 'lg',
    $weight: 'normal',
    $px: '2',
    $py: '0.5',
  },
  green: {
    $fg: 'festivalGreen',
    $bg: 'festivalGreen',
    $bgOpacity: 0.1,
    $radius: 'lg',
    $weight: 'normal',
    $px: '2',
    $py: '0.5',
  },
  sapphireDark: {
    $fg: 'white',
    $bg: 'sapphireDark',
    ...COMMON_LEGACY_PROPS,
  },
  festivalGreen: {
    $fg: 'white',
    $bg: 'festivalGreen',
    $borderColor: 'catskillWhite',
    ...COMMON_LEGACY_PROPS,
  },
} as const

export const SIZE: Record<TagSize, Omit<TagProps, '$variant' | '$size'>> = {
  sm: {
    $fs: '14',
  },
  md: {
    $fs: '16',
  },
} as const
